import { Action } from "@ngrx/store";

import { ValidityState } from "./state";
import * as Actions from "./actions";

export function validityReducer(
    state: ValidityState = new ValidityState(),
    action: Actions.Actions,
) {
    switch (action.type) {
        case Actions.Update.type:
            return action.validity;

        default:
            return state;
    }
}
